import React, { useEffect, useState, useCallback, useContext } from "react";
import { Switch, Route } from "react-router-dom";
import { useHistory } from "react-router-dom";
import PortalCliente from "./pages/PortalCliente/";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import Auth from "./pages/Auth";
import Base from "./base.js";
import { trackPromise } from "react-promise-tracker";
import GuLogin from "./pages/Login/GuLogin";
import caAPI from "./services/caAPI";
import RecebeLigacaoVoipModal from "./pages/Voip/RecebeLigacaoVoipModal";
import Template from "./pages/Configuracao/Template";
import Ramais from "./pages/Configuracao/Ramais";
import GestaoAgentesIa from "./pages/Configuracao/GestaoAgentesIa";
import BasesConhecimento from "./pages/Configuracao/BasesConhecimento";
import AtendimentosArquivados from "./pages/PortalCliente/RegistroAtendimento/AtendimentosArquivados";
import FilasAtendimento from "./pages/FilasAtendimento";
import {AtendentesContext} from "./contexts/AtendentesContext";
import {AtendimentoContext} from "./contexts/AtendimentoContext";
import {ModulosContext} from "./contexts/ModulosContext";
import {MeioComunicacaoContext} from "./contexts/MeioComunicacaoContext";
import {TipoAtendimentoContext} from "./contexts/TipoAtendimentoContext";
import {TipoHistoricoAtendimentoContext} from "./contexts/TipoHistoricoAtendimentoContext";
import {SituacaoAtendimentoContext} from "./contexts/SituacaoAtendimentoContext";
import QuadroHistoricoAtendimento from "./pages/QuadroHistoricoAtendimento";
import Integracoes from "./pages/Integracoes";
import ConectarNumeros from "./pages/ConectarNumeros";
import { RelatorioContext } from "./contexts/RelatorioContext";
import { TagsContext } from "./contexts/TagsContext";
import { EmpreendimentoContext } from "./contexts/EmpreendimentosContext";
import { CampanhaContext } from "./contexts/CampanhasContext";
import TempoOnline from "./pages/Configuracao/TempoOnline";
import GerenciarAssinatura from "./pages/Usuario/GerenciarAssinatura";
import { TiposAnexosTemplateContext } from "./contexts/TiposAnexosTemplateContext";
import { Dashboard } from "./pages/Dashboard";
import { MeuPerfil } from "./pages/Perfil";
import { DisparoEmMassa } from "./pages/DisparoEmMassa";
import { TemplateContext } from "./contexts/TemplateContext.js";
import { MapeamentoErrosTwillioContext } from "./contexts/MapeamentoErrosTwillioContext.js";
import { ContatosNotificacaoHistorico } from "./pages/ContatosNotificacaoHistorico/index.js";
import { ItensEnviadosPage } from "./pages/ItensEnviadosPage/index.js";
import { Dashboards } from "./pages/Dashboards/index.js";
import moment from 'moment'
import { guService } from "./services/guService.js";
import Swal from "sweetalert2";
import Questionarios from "./pages/Questionario/index.js";
import { TagsAtendimentoPage } from "./pages/TagsAtendimentoPage";
import AgendaContatos from "./pages/AgendaContatos";

moment.locale('pt-br')

export default function Routes() {
  const [tokenValido, setTokenValido] = useState(false);
  const {recarregarListaAtendentes, recarregarListaAtendentesGerenciados} = useContext(AtendentesContext);
  const {filtrarListaAtendimentos, carregaConfiguracoesDoUsuario, setFiltrosFixados} = useContext(AtendimentoContext);
  const {recarregarModulos} = useContext(ModulosContext);
  const {recarregarMeiosComunicacao} = useContext(MeioComunicacaoContext);
  const {recarregarRelatorios} = useContext(RelatorioContext);
  const {recarregarTiposAtendimento} = useContext(TipoAtendimentoContext);
  const {recarregarTiposHistoricoAtendimento} = useContext(TipoHistoricoAtendimentoContext);
  const {recarregarSituacoesAtendimento} = useContext(SituacaoAtendimentoContext);
  const {recarregarTags} = useContext(TagsContext);
  const {recarregarEmpreendimentos} = useContext(EmpreendimentoContext)
  const {recarregarCampanhas} = useContext(CampanhaContext)
  const {recarregarTiposAnexosTemplate} = useContext(TiposAnexosTemplateContext);
  const {recarregarTemplates} = useContext(TemplateContext);
  const {buscarMapeamentosErrosTwillio} = useContext(MapeamentoErrosTwillioContext);
  const telas = caAPI.getLocalState("telas");
  const history = useHistory();
  const valida = useCallback(async function() {
    let tokenAtual = caAPI.getLocalState("token");
    if (
      caAPI.getLocalState("token") !== null &&
      caAPI.getLocalState("idUsuario") !== null
    ) {
      caAPI
        .validaToken(tokenAtual)
        .then(async (res) => {
          caAPI.setLocalState("permissoes", res.data.permissoes);
          setTokenValido(res.data.valido);
          let filtrosFixados = await carregaConfiguracoesDoUsuario()
          const hoje = `${moment().format('YYYY-MM-DD')} 00:00:00`
          const filtrosInicial = {data_inicio: new Date(hoje), data_fim: new Date(hoje)};
          caAPI.setLocalState('filtros', filtrosFixados ? filtrosFixados : JSON.stringify(filtrosInicial));
          setFiltrosFixados(filtrosFixados ? true : false)
          if(filtrosFixados) {
            filtrosFixados = JSON.parse(filtrosFixados)
            for(let campo in filtrosFixados) {
              if(Array.isArray(filtrosFixados[campo]) && filtrosFixados[campo][0]?.label) {
                filtrosFixados[campo] = filtrosFixados[campo].map(option => option.value)
              }
            }
          }
          filtrarListaAtendimentos(filtrosFixados ? filtrosFixados : filtrosInicial)
          recarregarListaAtendentes();
          recarregarListaAtendentesGerenciados();
          recarregarModulos();
          recarregarMeiosComunicacao();
          recarregarTemplates();
          recarregarRelatorios();
          recarregarTiposAtendimento();
          recarregarTiposHistoricoAtendimento();
          recarregarSituacoesAtendimento();
          recarregarTags();
          recarregarEmpreendimentos();
          recarregarCampanhas();
          recarregarTiposAnexosTemplate();
          buscarMapeamentosErrosTwillio();
        })
        .catch((err) => {
          console.log(err);
          caAPI.logout();
        });
    } else {
      caAPI.logout();
    }
    window.addEventListener('message', handleMessage)

    return () => window.removeEventListener('message', handleMessage)
  }, []);

  useEffect(() => {
    if (!history.location.pathname.includes("gu-login")) {
      valida();
    }
  }, [history, valida]);

  function handleMessage(mensagem) {
		switch(mensagem.data?.type) {
			case 'login-modulo':
        if(mensagem.data?.idModulo != guService.ID_MODULO_CENTRAL_ATENDIMENTO || mensagem.data?.idInquilino != Number(caAPI.getLocalState('idCliente'))) {
          alterarCliente(mensagem.data)

          return
        }
				history.push(atob(mensagem.data?.tela))
				break
		}
	}

  function alterarCliente(dados) {
    trackPromise(guService.alterarCliente(dados?.idInquilino))
      .then(response => {
        acessarModulo(response.data.access_token, dados?.idModulo, dados?.tela)
      }).catch(error => {
        console.log(error)
        console.log(error?.response)
        Swal.fire('Ooops...', 'Houve um erro ao alterar o cliente.', 'error')
      })
  }

  function acessarModulo(token, idModulo, tela=null) {
    trackPromise(guService.acessarModulo(token, idModulo))
      .then(res => {
        window.location.href = `${res.data.modulo.uri}${res.data.token}:${caAPI.getLocalState('guToken')}${tela && `:${tela}` || ''}`
      }).catch(error => {
        console.log(error)
        console.log(error?.response)
        Swal.fire('Ooops...', 'Houve um problema ao autorizar acesso ao módulo.', 'error')
      })
  }

  return (
    <>
      <RecebeLigacaoVoipModal />
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/sair" component={Logout} />
        <Route path="/auth" component={Auth} />
        <Route path="/gu-login/:token" component={GuLogin} />
        {tokenValido && (
          <Base
            history={history}
            conteudo={
              <div style={{ height: "100%" }}>
                {telas?.includes("portal_cliente") && (
                  <>
                    <Route path="/" exact component={PortalCliente} />
                    <Route path="/atendimento" exact component={PortalCliente} />
                    <Route path="/itens-enviados" exact component={ItensEnviadosPage} />
                  </>
                )}
                <Route path="/configuracao/perfil" exact component={MeuPerfil} />
                {telas?.includes("template") && (
                  <Route
                    path="/configuracao/template"
                    exact
                    component={Template}
                  />
                )}
                {telas?.includes("label") && (
                  <Route path="/configuracao/ramais" exact component={Ramais} />
                )}
                {telas?.includes("agente_ia") && (
                  <>
                    <Route path="/configuracao/agentes-ia" exact component={GestaoAgentesIa} />
                    <Route path="/configuracao/bases-conhecimento" exact component={BasesConhecimento} />
                  </>
                )}
                {/* TODO habilitar as rotas para aparecer os filtros */}
                {/* {telas.includes("filtro_interacoes") && (
                  <Route path="/relatorios/filtro_interacoes" exact component={FiltroInteracoes} />
                )}
                {telas.includes("filtro_notificacoes") && (
                  <Route path="/relatorios/filtro_notificacoes" exact component={FiltroNotificacoes} />
                )}
                {telas.includes("relatorios_diversos") && (
                  <Route path="/relatorios/relatorios_diversos" exact component={RelatoriosDiversos} />
                )} */}
                {telas?.includes("arquivo") && (
                  <Route
                    path="/arquivo"
                    exact
                    component={AtendimentosArquivados}
                  />
                )}
                {telas?.includes("dashboard") && (
                  <Route
                    path="/dashboard"
                    exact
                    component={Dashboard}
                  />
                )}
                {telas?.includes("portal_cliente") && (
                  <Route
                    path="/filas-atendimento"
                    exact
                    component={FilasAtendimento}
                  />
                )}
                {telas?.includes("quadro_historico") && (
                  <Route
                    path="/quadro-historico"
                    exact
                    component={QuadroHistoricoAtendimento} />)}
                {telas?.includes("integracoes") && (
                  <>
                    <Route
                      path="/integracoes"
                      exact
                      component={Integracoes}
                    />
                    <Route
                      path="/conectar-numeros"
                      exact
                      component={ConectarNumeros}
                    />
                  </>
                )}
                {telas?.includes("contatos_notificacao_historico") && (
                  <Route
                    path="/configuracao/contatos_notificacao_historico"
                    exact
                    component={ContatosNotificacaoHistorico}
                  />
                )}
                {telas?.includes("questionario") && (
                  <Route path="/configuracao/questionario" exact component={Questionarios}/>
                )}
                {telas?.includes("tags_atendimento") && (
                  <Route path="/configuracao/tags_atendimento" exact component={TagsAtendimentoPage}/>
                )}
                {telas?.includes("portal_cliente") && (
                  <Route path="/agenda-contatos" exact component={AgendaContatos}/>
                )}
                <Route
                    path="/tempo-online"
                    exact
                    component={TempoOnline}
                  />
                <Route path="/usuario/gerenciar-assinatura" exact component={GerenciarAssinatura} />
                <Route path="/disparo-massa" exact component={DisparoEmMassa}/>
                <Route path="/dashboards" exact component={Dashboards}/>
              </div>
            }
          ></Base>
        )}
        <Route path="*">
          <div>Carregando...</div>
        </Route>
      </Switch>
    </>
  );
}
